module.exports = __webpack_public_path__ + "media/images/emoticons/aries-7ecaef31c07df004abdc80dfbfd081e8.gif";